import React from 'react';
import { AccountAction } from '@esg/ui';

export const ManagementAccountAction: React.FC = () => {
    return (
        <AccountAction
            label='Izisalon Admin'
        />
    );
};